import { g as getLocale, t as trackMessageCall } from "./runtime.js";
const en_original_link1 = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Original link`;
  }
);
const de_original_link1 = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Original Link`;
  }
);
const sp_original_link1 = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Original link`;
  }
);
const original_link1 = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("original_link1", locale);
  if (locale === "en") return en_original_link1();
  if (locale === "de") return de_original_link1();
  return sp_original_link1();
};
const en_redirect_to = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Redirect to Website`;
  }
);
const de_redirect_to = en_redirect_to;
const sp_redirect_to = en_redirect_to;
const redirect_to = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("redirect_to", locale);
  if (locale === "en") return en_redirect_to();
  if (locale === "de") return de_redirect_to();
  return sp_redirect_to();
};
const en_shrtn_unsecure_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `This link is propably not secure`;
  }
);
const de_shrtn_unsecure_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Dieser Link ist möglicherweise unsicher`;
  }
);
const sp_shrtn_unsecure_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Es probable que este enlace no sea seguro`;
  }
);
const shrtn_unsecure_headline = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("shrtn_unsecure_headline", locale);
  if (locale === "en") return en_shrtn_unsecure_headline();
  if (locale === "de") return de_shrtn_unsecure_headline();
  return sp_shrtn_unsecure_headline();
};
const en_shrtn_unsecure_subline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Please use the link only if you trust the sender. Inform the creator or report it.`;
  }
);
const de_shrtn_unsecure_subline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Bitte verwenden Sie den Link nur, wenn Sie den Absender vertrauen. Informieren Sie den Ersteller oder melden Sie den Link.`;
  }
);
const sp_shrtn_unsecure_subline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Por favor, utiliza el enlace solo si confías en el remitente. Informa al creador o reporta el problema.`;
  }
);
const shrtn_unsecure_subline = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("shrtn_unsecure_subline", locale);
  if (locale === "en") return en_shrtn_unsecure_subline();
  if (locale === "de") return de_shrtn_unsecure_subline();
  return sp_shrtn_unsecure_subline();
};
const en_shrtn_outdated_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Your link seems to be outdated`;
  }
);
const de_shrtn_outdated_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Der Link scheint veraltet zu sein`;
  }
);
const sp_shrtn_outdated_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Parece que tu enlace está desactualizado`;
  }
);
const shrtn_outdated_headline = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("shrtn_outdated_headline", locale);
  if (locale === "en") return en_shrtn_outdated_headline();
  if (locale === "de") return de_shrtn_outdated_headline();
  return sp_shrtn_outdated_headline();
};
const en_shrtn_outdated_subline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Please contact the creator of the link or create a new link if you are the owner`;
  }
);
const de_shrtn_outdated_subline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Bitte kontaktieren Sie den Ersteller des Links oder erstellen Sie einen neuen Link, falls Sie der Eigentümer sind`;
  }
);
const sp_shrtn_outdated_subline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Por favor, contacta al creador del enlace o crea un enlace nuevo si eres el propietario`;
  }
);
const shrtn_outdated_subline = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("shrtn_outdated_subline", locale);
  if (locale === "en") return en_shrtn_outdated_subline();
  if (locale === "de") return de_shrtn_outdated_subline();
  return sp_shrtn_outdated_subline();
};
const en_shrtn_passphrase_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `This link is protected`;
  }
);
const de_shrtn_passphrase_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Dieser Link ist geschützt`;
  }
);
const sp_shrtn_passphrase_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Este enlace está protegido`;
  }
);
const shrtn_passphrase_headline = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("shrtn_passphrase_headline", locale);
  if (locale === "en") return en_shrtn_passphrase_headline();
  if (locale === "de") return de_shrtn_passphrase_headline();
  return sp_shrtn_passphrase_headline();
};
const en_shrtn_passphrase_subline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Please enter the secret to access this link`;
  }
);
const de_shrtn_passphrase_subline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Gebe das Kennwort ein, um weitergeleitet zu werden`;
  }
);
const sp_shrtn_passphrase_subline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Por favor, introduce el secreto para acceder a este enlace`;
  }
);
const shrtn_passphrase_subline = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("shrtn_passphrase_subline", locale);
  if (locale === "en") return en_shrtn_passphrase_subline();
  if (locale === "de") return de_shrtn_passphrase_subline();
  return sp_shrtn_passphrase_subline();
};
const en_shrtn_passphrase_info = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Enter the secret to access this link`;
  }
);
const de_shrtn_passphrase_info = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Gebe hier dein Kennwort ein`;
  }
);
const sp_shrtn_passphrase_info = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Introduce el secreto para acceder a este enlace`;
  }
);
const shrtn_passphrase_info = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("shrtn_passphrase_info", locale);
  if (locale === "en") return en_shrtn_passphrase_info();
  if (locale === "de") return de_shrtn_passphrase_info();
  return sp_shrtn_passphrase_info();
};
const en_secret = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Secret`;
  }
);
const de_secret = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Kennwort`;
  }
);
const sp_secret = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Secreto`;
  }
);
const secret = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("secret", locale);
  if (locale === "en") return en_secret();
  if (locale === "de") return de_secret();
  return sp_secret();
};
export {
  shrtn_outdated_headline as a,
  shrtn_outdated_subline as b,
  shrtn_passphrase_headline as c,
  shrtn_passphrase_info as d,
  shrtn_passphrase_subline as e,
  shrtn_unsecure_headline as f,
  shrtn_unsecure_subline as g,
  original_link1 as o,
  redirect_to as r,
  secret as s
};
